var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPotx64 = function SvgPotx64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 2048 2048"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1709 178q19 8 19 29v1681q0 14-9 23t-23 9H512q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-288H200q-30 0-51-21t-21-51V680q0-30 21-51t51-21h152V160q0-14 9-23t23-9h1209q7 0 13 3m-38 1629V384H384v224h536q30 0 51 21t21 51v720q0 30-21 51t-51 21H384v288M1696 277l-96-34v1517q0 14-9 23t-23 9H512v96h1184m-544-832h288q0 60-22 113-23 52-62 91t-91 62q-53 22-113 22-26 0-49-4-24-4-47-12V784q23-8 47-12 23-4 49-4m-678 506v-165h87q39 0 72-11 32-12 55-33 22-21 35-49 12-29 12-64 0-69-43-107-43-39-126-39H385v468m831-570q60 0 113 23 52 22 91 61t62 92q22 52 22 112h-288M554 878q87 0 87 78 0 39-23 60t-67 21h-77V878z",
    className: "potx_64_svg__OfficeIconColors_HighContrast"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M1677 229q14 0 23 10 9 9 9 22v1606q0 13-9 23-9 9-23 9H528q-14 0-23-9-9-10-9-23v-91H396q-14 0-23-9-9-10-9-23V292q0-14 9-23t23-9h127q1-13 10-22t22-9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#797774",
    d: "M1728 256v1632q0 14-9 23t-23 9H512q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23V304q0-14 9-23t23-9h1184q14 0 23 9t9 23v1456q0 14-9 23t-23 9H512v96h1184V256m-128 1504V304H384v1456z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED6C47",
    d: "M1216 704q60 0 113 23 52 22 91 61t62 92q22 52 22 112h-288m224 64q0 60-22 113-23 52-62 91t-91 62q-53 22-113 22-26 0-49-4-24-4-47-12v-272z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F6B",
    d: "M1056 784q23-8 47-12 23-4 49-4v288h-96z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.498,
    d: "M1216 704q60 0 113 23 52 22 91 61t62 92q22 52 22 112h-288z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C43E1C",
    d: "M920 608q30 0 51 21t21 51v720q0 30-21 51t-51 21H200q-30 0-51-21t-21-51V680q0-30 21-51t51-21z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M566 806q83 0 126 39 43 38 43 107 0 35-12 64-13 28-35 49-23 21-55 33-33 11-72 11h-87v165h-89V806m89 231h77q44 0 67-21t23-60q0-78-87-78h-80z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F6B",
    d: "M1600 384H352V160q0-14 9-23t23-9h1209q1 0 7 2v113z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED6C47",
    d: "M1709 178q19 8 19 29v81l-128-45V130q4 0 6 1m-6 253H352v-32h1248z"
  })));
};
export default SvgPotx64;